import _get from 'lodash/get';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _toString from 'lodash/toString';
import _head from 'lodash/head';
import _join from 'lodash/join';
import _compact from 'lodash/compact';
import { EMPTY_OBJECT, EMPTY_ARRAY } from 'tbase/app.constants';
import vendorReader from '../readers/Vendor';
import vendorSiteReader from '../readers/VendorSite';
import vendorAddressReader from '../readers/VendorAddress';
export var getVendorOptionLabel = function getVendorOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var vendorName = _get(option, 'data.vendorName') || '';
  var vendorId = _get(option, 'data.externalId') || _get(option, 'data.vendorDisplayId') || '';
  if (!vendorId) return vendorName;
  return "".concat(vendorId, " - ").concat(vendorName);
};
export var getSiteOptions = function getSiteOptions() {
  var sites = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  return _map(sites, function (site) {
    var id = site.id,
        siteName = site.siteName;
    return {
      value: _toString(id),
      label: siteName ? "".concat(siteName, " - ").concat(id) : id
    };
  });
};
export var getSiteDetails = function getSiteDetails(sites, selectedSiteId) {
  var selectedSite = _find(sites, function (o) {
    return _get(o, 'id') === selectedSiteId;
  });

  var siteContacts = _get(selectedSite, 'pointOfContacts', EMPTY_ARRAY);

  return _find(siteContacts, function (contact) {
    return contact["default"];
  }) || EMPTY_OBJECT;
};
export var getSites = function getSites(option) {
  return _get(option, 'optionData.sites', EMPTY_ARRAY);
};
export var getPrimarySiteDetails = function getPrimarySiteDetails(vendor) {
  var vendorSites = vendorReader.sites(vendor) || EMPTY_ARRAY;
  return _find(vendorSites, vendorSiteReader.primary) || _head(vendorSites);
};
export var getPrimarySiteId = function getPrimarySiteId(vendor) {
  var primarySite = getPrimarySiteDetails(vendor);
  var primarySiteId = vendorSiteReader.id(primarySite);
  return primarySiteId;
};
export var getVendorAddress = function getVendorAddress(vendorAddress) {
  return _join(_compact([vendorAddressReader.line1(vendorAddress), vendorAddressReader.city(vendorAddress), vendorAddressReader.state(vendorAddress), vendorAddressReader.country(vendorAddress)]), ' ');
};